// Sales results are downloaded through the authenticated application asset API.
// Provider URLs and IDs are never accepted as browser media authority.
export const hasSalesVideoResult = (job) => Boolean(job?.status === "completed" &&
  /^[a-f0-9]{24}$/i.test(job.id || "") && job.video_url === `/api/assets/${job.id}`);

export const isCurrentSalesPreview = (preview, job, editing = false) => Boolean(!editing &&
  job && preview?.id === job.id && preview.updated_at === job.updated_at &&
  preview.reliable === true && preview.generation_ready === true &&
  Number.isSafeInteger(preview.estimated_credits) && preview.estimated_credits > 0);
